import { combineReducers } from "redux";
import { LOGOUT } from "../types";
import loadingReducer from "./loadingReducer";
import authReducer from "./authReducer";
import nftReducer from "./nftReducer";
import userReducer from "./userReducer";
import txnReducer from "./txnRecucer";

const appReducer = combineReducers({
    auth: authReducer,
    loading: loadingReducer,
    nfts: nftReducer,
    users: userReducer,
    txns: txnReducer,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
